import JSXComponent from "../../dist/jsx-render/JSXComponent";
import dom from "../../dist/jsx-render/dom";
import { app } from "../Frame/App";
import { ComponentBase } from "./ComponentBase";
import { select } from "d3";

export type SelectComponentProps = {
    model: any;
    field?: string;
    options?: { name: string, value: string }[];
    id?: string;
    disabled?: boolean;

    name?: string;
    additionalCssClasses?: string;
    changeEvent?: (event: Event) => void;
    addEmptyItem?: boolean;
}

export class SelectComponent extends ComponentBase {

    props: SelectComponentProps;
    constructor(props: SelectComponentProps) { super(props) }

    guid = app.createGuid();

    element: HTMLElement;
    getElement = () => {
        this.element = <div className={"form-group" + (this.props.additionalCssClasses ? " " + this.props.additionalCssClasses : "")}>
            {this.props.name
                ? <label className="form-label" for={this.props.id ? this.props.id : this.guid}>{this.props.name}</label>
                : []}
            <select id={this.props.id ? this.props.id : this.guid}
                className="form-control">
                {this.props.options.map(m =>
                    <option value={m.value}>{m.name}</option>)}
            </select>
        </div>;
    }

    private updateModelFromControl = (value: string, field: string, model: any) => {
        model.setPropertyByPath(field, value);
    }

    handleSelectionChanged = (event: Event) => {
        if (this.props.field) {
            this.updateModelFromControl((event.target as HTMLInputElement).value, this.props.field, this.props.model);
        }

        if (this.props.changeEvent) {
            this.props.changeEvent(event);
        }
    }

    render() {
        if (this.props.addEmptyItem === true && this.props.options) {
            this.props.options.splice(0, 0, { name: "", value: undefined });
        }

        this.getElement();

        let selectElement = this.element.querySelector("select") as HTMLSelectElement;
        selectElement.addEventListener('change', this.handleSelectionChanged);

        if (this.props.disabled === true) {
            selectElement.disabled = true;
        }

        if (this.props.model[this.props.field]) {
            try {
                selectElement.value = this.props.model[this.props.field];
            } catch (Err) {
                console.log(Err);
            }
        } else {
            // If the select control does not have an empty item, select the first item and set it to the model.
            if (selectElement.options.length > 0) {
                this.props.model[this.props.field] = selectElement.options[0].value;
            }
        }



        return this.element;
    }

    dispose() { }
    validate() { }
}